import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgPersonKey = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#88827E"
      d="M9 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4Zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2ZM3.3 14 .75 21h12.24l-.72-2H3.61l1.09-3h8.6l1.82 5h2.13l-2.55-7H3.3Z"
    />
    <path
      fill="#88827E"
      fillRule="evenodd"
      d="M19 6a3 3 0 0 1 .343 5.98l.8.79-1.286 1.268 1.286 1.27L18.429 17l-1.286-1.27v-4.378A2.992 2.992 0 0 1 16 9a3 3 0 0 1 3-3Zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPersonKey;
